import { render } from "./VoiceMessagePlayer.vue?vue&type=template&id=49e49c93&scoped=true"
import script from "./VoiceMessagePlayer.vue?vue&type=script&lang=js"
export * from "./VoiceMessagePlayer.vue?vue&type=script&lang=js"

import "./VoiceMessagePlayer.vue?vue&type=style&index=0&id=49e49c93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e49c93"]])

export default __exports__